/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-debugger */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-unused-vars */
import { motion } from 'framer-motion';
import React, {
    useState, useContext, useEffect, useCallback, useRef,
} from 'react';
import ReactModal from 'react-modal';
import ReactSlidingPane from 'react-sliding-pane';
import HeaderContext from '../../../Components/Context/HeaderContext';
import EmptyScreen from '../../../Components/GlobalEmplyPage';
import Pagination from '../../../Components/Pagination';
import ItemSkeleton from '../../../Components/Skeletons/itemSkeleton';
import { distributorService } from '../../../service/distributor.service';
import TableHeader from '../../../TableHeader';
import Filters from './Filters';
import PendingApprovalEmptyScreen from './PendingApprovalEmptyScreen';
import PendingApprovalList from './PendingApprovalList';

export default function ManagePendungApprovals() {
    const [isPaneOpen, setisPaneOpen] = useState(false);
    const [NoUser, setNoUser] = useState(false);
    const [showSuccess, setshowSuccess] = useState(false);
    const [isLoaded, setisLoaded] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState('');
    const [EditDAte, setEditDAte] = useState([]);
    const [editpaneopen, seteditpaneopen] = useState(false);
    const [title, settitle] = useState(' Otp Verification Successful!');
    const [sort, setsort] = useState(false);
    const [sortType, setsortType] = useState('created_at+asc');
    const [alertShow, setalertShow] = useState(false);
    const [linksentPopup, setlinksentPopup] = useState(false);
    const [searchValue, setsearchValue] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [loading, setloading] = useState(false);
    const [statusLoader, setstatusLoader] = useState('');
    const [nextPageHasData, setnextPageHasData] = useState(false);
    const [filter, setfilter] = useState(false);
    const [OpenPopup, setOpenPopup] = useState('');
    const [actvloader, setactvloader] = useState(false);
    const [showPopup, setshowPopup] = useState(false);
    const [renderPage, setrenderPage] = useState(false);
    const [render, setrender] = useState(false);
    const [filterValue, setfilterValue] = useState('');
    const [color, setcolor] = useState(false);
    const [exportClick, setexportClick] = useState(false);
    const [isEditId, setisEditId] = useState('');
    const [alldata, setalldata] = useState({});
    const [orderList, setorderList] = useState([]);
    const [filterOpen, setfilterOpen] = useState(true);
    const [exportSelected, setexportSelected] = useState('');
    const [filterUrl, setfilterUrl] = useState('');
    const [onlyPending, setOnlyPending] = useState(true);
    const [selected, setselected] = useState({
        start_date: '',
        end_date: '',
    });
    const [Filter, setFilter] = useState({
        order_type: [],
        order_status: [],
        payment_type: [],
    });
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
        HardRefresh,
        setHardRefresh,
        collapsed,
    } = useContext(HeaderContext);
    useEffect(() => {
        if (searchValue === debouncedSearch) return undefined;
        const timer = setTimeout(() => {
            setisLoaded(true);
            setDebouncedSearch(searchValue);
            setCurrentPage(1);
        }, 500);
        return () => clearTimeout(timer);
    }, [searchValue, debouncedSearch]);

    const isFirstListChange = useRef(true);
    useEffect(() => {
        if (isFirstListChange.current) {
            isFirstListChange.current = false;
            return;
        }
        setisLoaded(true);
    }, [currentPage, sortType, onlyPending]);

    const handleFetch = useCallback(((url, clear) => {
        // const page = handlePageValue();
        setHardRefresh(false);
        let params = clear ? '' : (url || filterUrl);
        if (url || clear) {
            setisLoaded(true);
            // Not on the first page: reset it and let the refetch apply the new filter, so the API is called once
            if (currentPage !== 1) {
                setCurrentPage(1);
                return;
            }
        }
        if (onlyPending === true) {
            params += '&pending=true';
        }
        distributorService.PendingApprovalList(currentPage, sortType, debouncedSearch, params).then((resp) => {
            if (resp?.data?.data?.Items.length > 0) {
                setnextPageHasData(true);
                setalldata(resp.data.data);
                setorderList(resp.data.data.Items);
                setNoUser(false);
                setisLoaded(false);
            } else {
                setNoUser(true);
                setisLoaded(false);
                setnextPageHasData(false);
                if (debouncedSearch !== '' || params !== '') {
                    setorderList([]);
                    setalldata([]);
                }
                setisLoaded(false);
            }
            setfilter(false);
        });

        // setisLoaded(false);
    }), [currentPage, debouncedSearch, filterValue, sortType, onlyPending]);
    const handleExport = useCallback((() => {
        let params = filterUrl;
        if (onlyPending === true) {
            params += '&pending=true';
        }
        distributorService.PendingApprovalList(currentPage, sortType, debouncedSearch, params, exportSelected).then((val) => {
            if (val.data.success_status) {
                setshowPopup(true);
                settitle(val.data.message);
                setexportClick(false);
                setexportSelected('');
                window.open(val.data.url, '_blank');
                setTimeout(() => {
                    settitle('');
                    setshowPopup(false);
                }, 2000);
            }
        });
    }), [exportSelected]);

    useEffect(() => {
        if (exportSelected !== '') {
            handleExport();
        }
    }, [handleExport]);

    useEffect(() => {
        handleFetch();
    }, [handleFetch]);

    const handlePageClick = async (data) => {
        const page = data.selected + 1;
        setCurrentPage(page);
    };

    return (
        <>
            <TableHeader
                setsearchValue={setsearchValue}
                searchValue={searchValue}
                filter={filter}
                setfilter={setfilter}
                setexportSelected={setexportSelected}
                exportClick={exportClick}
                exportSelected={exportSelected}
                setexportClick={setexportClick}
                setisEditId={setisEditId}
                list={orderList}
                setCurrentPage={setCurrentPage}
                NoAddButton
                pendingToggle
                pending={onlyPending}
                setPending={setOnlyPending}
            />
            {!isLoaded && orderList.length === 0
            && <EmptyScreen search="yes" text="no Pending approval" all={debouncedSearch.length > 0 ? 'under searched term' : 'found'} />}
            {isLoaded ? <ItemSkeleton />
                : (
                    <div>
                        {!isLoaded && orderList.length > 0 && (
                            <div
                                className="overflow-auto dropdown-menu sticky top-0 left-0"
                                style={{ height: 'calc(100vh - 298px)' }}
                            >
                                <table className="w-full table-auto relative">

                                    <motion.thead
                                        animate={{ opacity: 1, x: 0 }}
                                        initial={{ opacity: 0, x: -10 }}
                                        exit={{ opacity: 0, x: -10 }}
                                        transition={{ duration: 0.15 }}
                                        style={{ zIndex: '99', opacity: '1', transform: 'none' }}
                                        className="rounded-bl-lg rounded-tl-lg min-w-[158px] sticky top-0 left-0 bg-[#555259]"
                                    // style={{ zIndex: OpenPopup || exportClick ? '99' : '99' }}
                                    >
                                        <tr className="bg-[#555259] h-10">
                                            <th className="py-2.5 px-4 rounded-bl-lg rounded-tl-lg min-w-[158px] sticky top-0 left-0 bg-[#555259] text-left" scope="col" style={{ minWidth: '150px' }}>
                                                <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                    Order No.
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 px-4  text-left">
                                                <span className="text-xs5 p-1  text-[#FFFFFF] flex items-center" style={{ minWidth: '190px' }}>
                                                    Distributor/Customer Code
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 px-4 text-left">
                                                <span className="text-xs5  text-[#FFFFFF] flex items-center" style={{ minWidth: '250px' }}>
                                                    Distributor/Customer Name
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 px-4 text-left  min-w-[190px]">
                                                <span className="text-xs5  text-[#FFFFFF] flex items-center">
                                                    Order Created Date
                                                    <a href="#" className="pl-[5px]">
                                                        <motion.img
                                                            animate={{
                                                                rotate: sortType === 'created_at+asc' ? 180 : 0,
                                                            }}
                                                            className={`${sortType === 'created_at+asc' ? 'image-rotate' : ''}`}
                                                            src="/images/sort.svg"
                                                            alt="icon"
                                                            data-testid="order_created_date"
                                                            onClick={() => {
                                                                if (sortType === 'created_at+asc') {
                                                                    setsortType('created_at+desc');
                                                                } else if (sortType === 'created_at+desc') {
                                                                    setsortType('created_at+asc');
                                                                } else {
                                                                    setsortType('created_at+asc');
                                                                }
                                                                setCurrentPage(1);
                                                            // setisLoaded(true);
                                                            }}
                                                        />
                                                    </a>
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 px-4 text-left">
                                                <span className="text-xs5  text-[#FFFFFF] flex items-center" style={{ minWidth: '190px' }}>
                                                    Customer PO Number
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 px-4 text-left">
                                                <span className="text-xs5  text-[#FFFFFF] flex items-center" style={{ minWidth: '150px' }}>
                                                    Order Type
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 px-4 text-center ">
                                                <span className="text-xs5  text-[#FFFFFF] flex items-center" style={{ minWidth: '150px' }}>
                                                    Total line items
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 px-4 text-left">
                                                <span className="text-xs5  text-[#FFFFFF] flex items-end justify-end" style={{ minWidth: '150px' }}>
                                                    Total Amount
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 px-4">
                                                <span className="text-xs5  text-[#FFFFFF] flex items-center justify-center" style={{ minWidth: '200px' }}>
                                                    Type
                                                    <a href="#" className="pl-[5px]">
                                                        <motion.img
                                                            animate={{
                                                                rotate: sortType === 'distributor_type+asc' ? 180 : 0,
                                                            }}
                                                            className={`${sortType === 'distributor_type+asc' ? 'image-rotate' : ''}`}
                                                            src="/images/sort.svg"
                                                            alt="icon"
                                                            data-testid="order_type"
                                                            onClick={() => {
                                                                if (sortType === 'distributor_type+asc') {
                                                                    setsortType('distributor_type+desc');
                                                                } else if (sortType === 'distributor_type+desc') {
                                                                    setsortType('distributor_type+asc');
                                                                } else {
                                                                    setsortType('distributor_type+asc');
                                                                }
                                                                setCurrentPage(1);
                                                            // setisLoaded(true);
                                                            }}
                                                        />
                                                    </a>
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 px-4">
                                                <span className="text-xs5  text-[#FFFFFF] flex items-end justify-center">
                                                    Category
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 px-4 text-left  min-w-[172px]">
                                                <span className="text-xs5  text-[#FFFFFF] flex items-center">
                                                    WF Status
                                                    <a href="javascript:void(0)" className="pl-[5px]">
                                                        <motion.img
                                                            animate={{
                                                                rotate: sortType === 'work_flow_status+asc' ? 180 : 0,
                                                            }}
                                                            className={`${sortType === 'work_flow_status+asc' ? 'image-rotate' : ''}`}
                                                            src="/images/sort.svg"
                                                            data-testid="wf_status"
                                                            alt="icon"
                                                            onClick={() => {
                                                                if (sortType === 'work_flow_status+asc') {
                                                                    setsortType('work_flow_status+desc');
                                                                } else if (sortType === 'work_flow_status+desc') {
                                                                    setsortType('work_flow_status+asc');
                                                                } else {
                                                                    setsortType('work_flow_status+asc');
                                                                }
                                                                setCurrentPage(1);
                                                            // setisLoaded(true);
                                                            }}
                                                        />
                                                    </a>
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 px-4 rounded-tr-lg rounded-br-lg min-w-[100px] sticky top-0 right-0 bg-[#555259]">
                                                <span
                                                    className="text-xs5 font-bold text-[#FFFFFF]"
                                                >
                                                    Action
                                                </span>
                                            </th>
                                        </tr>
                                    </motion.thead>
                                    <PendingApprovalList
                                        setisPaneOpen={setisPaneOpen}
                                        // getUserList={getDAPList}
                                        DAPList={orderList}
                                        setisLoaded={setisLoaded}
                                        currentPage={currentPage}
                                        totalPage={totalPage}
                                        setCurrentPage={setCurrentPage}
                                        setrender={setrender}
                                        setEditDAte={setEditDAte}
                                        render={render}
                                        seteditpaneopen={seteditpaneopen}
                                        EditDAte={EditDAte}
                                        // handleSort={handleSort}
                                        setsort={setsort}
                                        sort={sort}
                                        setsortType={setsortType}
                                        filter={filter}
                                        OpenPopup={OpenPopup}
                                        setOpenPopup={setOpenPopup}
                                        actvloader={actvloader}
                                        setactvloader={setactvloader}
                                        isEditId={isEditId}
                                        setisEditId={setisEditId}
                                        isLoaded={isLoaded}
                                    />

                                    {/* <ReactModal isOpen={filter}>
                    <Filters close={setfilterOpen} setcurrentpage={setCurrentPage} setFilter={setFilter} Filter={Filter} handleFetch={handleFetch} setfilterUrl={setfilterUrl} />
                </ReactModal> */}

                                </table>
                            </div>
                        )}
                        { !isLoaded && orderList && orderList.length > 0 && (
                            <Pagination
                                handlePageClick={handlePageClick}
                                totalPage={alldata.number_of_pages}
                                List={alldata}
                                currentPage={currentPage}
                            />
                        )}
                    </div>
                )}
            <ReactSlidingPane
                from="right"
                isOpen={filter}
                width="30%"
                className="z-50"
                hideHeader
                closeIcon
                onRequestClose={() => setfilter(false)}
            >
                <Filters
                    // close={setfilter}
                    setfilter={setfilter}
                    setcurrentpage={setCurrentPage}
                    setFilter={setFilter}
                    Filter={Filter}
                    handleFetch={handleFetch}
                    setfilterUrl={setfilterUrl}
                    selected={selected}
                    setselected={setselected}
                    setisPaneOpen={setisPaneOpen}
                />

            </ReactSlidingPane>
        </>
    );
}
